<script>
export let msg_show;
export let msg_text;
export let msg_type;


import { get } from 'svelte/store';
import { createForm } from 'svelte-forms-lib';
import * as yup from 'yup';
import { navigateTo, Navigate } from 'svelte-router-spa';

import { onMount } from 'svelte';



import MsgCard from 'components/elements/MsgCard.svelte';


import FormFieldError from 'components/forms/FormFieldError.svelte';



const forms_api_url = app_.env.FORMS_API_URL;

const hcaptcha_site_key = app_.env.HCAPTCHA_SITE_KEY;


let captcha;



let loading = false;



const {
	form,
	errors,
	state,
	// handleBlur,
	handleChange,
	handleSubmit,
	setField,
} = createForm({
	initialValues: {
		team_instance_id: null,
		contact_email: '',
		contact_phone_number: '',
		player_full_name: '',

		jersey_sponsors: [
			{
				name_of_sponsor: '',
				no_sponsor_bar: false,
				sponsor_line_1: '',
				sponsor_line_2: '',
				amount: null,
			},
		],

	},
	validationSchema: yup.object().shape({
		team_instance_id: yup
			.number()
			.required('Must be a valid team!'),
		contact_email: yup
			.string()
			.email('Must be a valid email!')
			.required('Email required!'),
		contact_phone_number: yup
			.string()
			.required('Phone number required!'),

		player_full_name: yup
			.string()
			.required('Player name required!'),

		jersey_sponsors: yup
			.array()
			.of(
				yup.object().shape({
					name_of_sponsor: yup
								.string()
								.required('Name of sponsor required!'),
					no_sponsor_bar: yup
									.bool()
									.nullable(),
					sponsor_line_1: yup
									.string()
									.max(16, '14 Characters Maximum!'),
					sponsor_line_2: yup
									.string()
									.max(16, '14 Characters Maximum!'),
					amount: yup
							.number()
							// .nullable()
							.label('Tag'),
				}),
			)
			.label(''),

		'h-captcha-response': yup
			.string()
			.required(),
	}),
	onSubmit: values => {

		confirm('Do you confirm your jersey sponsor(s) order?');

		loading = true;

		console.log(JSON.stringify(values));

		let body_data = JSON.stringify(values, removeEmptyStringAndNull);

		console.log(body_data);

		submitForm(body_data).then(data => {

			msg_type = 'success';
			msg_show = true;
			msg_text = '...';

			successfully_submitted = true;

		}).catch(error => {

			msg_type = 'error';
			msg_show = true;

		}).finally(() => {

			loading = false;

		});

	}
});



let active_conference_instance_id;

let active_division_instance_id;

let active_team_instance_id;


const conference_instances = [
	{
		id: 1,
		conferences_sc: {
			name: 'Test Conference 1',
		},
	},
	{
		id: 2,
		conferences_sc: {
			name: 'Test Conference 2',
		},
	},
];

let active_conference_instances = conference_instances;

const division_instances = [
	{
		id: 1,
		conference_instance_id: 1,
		divisions_sc: {
			name: 'Test Division 1',
		},
	},
	{
		id: 2,
		conference_instance_id: 1,
		divisions_sc: {
			name: 'Test Division 2',
		},
	},
	{
		id: 3,
		conference_instance_id: 2,
		divisions_sc: {
			name: 'Test Division 3',
		},
	},
	{
		id: 4,
		conference_instance_id: 2,
		divisions_sc: {
			name: 'Test Division 4',
		},
	},
];

let active_division_instances = [];


const team_instances = [
	{
		id: 1,
		division_instance_id: 1,
		teams_sc: {
			name: 'Test Team 1',
		},
	},
	{
		id: 2,
		division_instance_id: 1,
		teams_sc: {
			name: 'Test Team 2',
		},
	},
	{
		id: 3,
		division_instance_id: 2,
		teams_sc: {
			name: 'Test Team 3',
		},
	},
	{
		id: 4,
		division_instance_id: 2,
		teams_sc: {
			name: 'Test Team 4',
		},
	},
	// ...
	{
		id: 5,
		division_instance_id: 3,
		teams_sc: {
			name: 'Test Team 5',
		},
	},
	{
		id: 6,
		division_instance_id: 3,
		teams_sc: {
			name: 'Test Team 6',
		},
	},
	{
		id: 7,
		division_instance_id: 4,
		teams_sc: {
			name: 'Test Team 7',
		},
	},
	{
		id: 8,
		division_instance_id: 4,
		teams_sc: {
			name: 'Test Team 8',
		},
	},
];

let active_team_instances = [];




$: {
	console.log(active_conference_instance_id);
	active_division_instance_id = '';
	$form.team_instance_id = '';
	active_division_instances = division_instances.filter(el => el.conference_instance_id == active_conference_instance_id);
}



$: {
	console.log(active_division_instance_id);
	$form.team_instance_id = '';
	active_team_instances = team_instances.filter(el => el.division_instance_id == active_division_instance_id);
}


$: {
	// console.log($form.team_instance_id);
}



async function submitForm(body_data) {

	const url = `#`;

	const resp = await fetch(url, {
		method: 'POST',
		body: body_data,
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		msg_text = result.detail;
		throw new Error('Error!');
	}

	return result;

}



onMount(() => {
	// Append hCaptcha Script
	const loadhCaptcha = (callback) => {
		const existingScript = document.getElementById('hCaptcha');
		if (!existingScript) {
			const script = document.createElement('script');
			script.src = 'https://hcaptcha.com/1/api.js?recaptchacompat=off&render=explicit';
			script.id = 'hCaptcha';
			document.body.appendChild(script);
			script.onload = () => {
				if (callback) callback();
			};
		}
		if (existingScript && callback) callback();
	};

	// Render hCaptcha
	const injecthCaptcha = () => {
		hcaptcha.render(captcha, {
			theme: 'light',
			sitekey: hcaptcha_site_key,
			recaptchacompat: false,
			callback: (token) => {
				$form['h-captcha-response'] = token;
			},
			'expired-callback': (token) => {
				// $form['h-captcha-response'] = token;
			},
			'error-callback': (token) => {
				// $form['h-captcha-response'] = token;
			}
		});
	};
	// Run load and provide callback
	loadhCaptcha(() => {
		injecthCaptcha();
	});
});




function addNewJerseySponsor() {

	$form.jersey_sponsors = [...$form.jersey_sponsors, {
		name_of_sponsor: '',
		no_sponsor_bar: false,
		sponsor_line_1: '',
		sponsor_line_2: '',
		amount: null,
	}];


}


function removeJerseySponsor(i) {

	// ---
	$form.jersey_sponsors.splice(i, 1);

	$form.jersey_sponsors = $form.jersey_sponsors;

	$errors.jersey_sponsors.splice(i, 1);

	$errors.jersey_sponsors = $errors.jersey_sponsors;

	// console.log($errors.jersey_sponsors);

}


</script>


<style>

form {

}

</style>


<form on:submit={handleSubmit}>

	<div class="field">

		<div class="control">

			<label>
				Conference
			</label>

			<div class="select is-fullwidth">

				<select bind:value={active_conference_instance_id} disabled={loading}>

					<option value="">
						Team Conference
					</option>

					{#each active_conference_instances as conference_instance}

						<option value="{conference_instance.id}">
							{conference_instance.conferences_sc.name}
						</option>

					{/each}
					
				</select>

			</div>

		</div>

	</div>


	{#if !!active_conference_instance_id}

	<div class="field">

		<div class="control">

			<label>
				Division
			</label>

			<div class="select is-fullwidth">

				<select bind:value={active_division_instance_id} disabled={loading}>

					<option value="">
						Team Division
					</option>

					{#each active_division_instances as division_instance}

						<option value="{division_instance.id}">
							{division_instance.divisions_sc.name}
						</option>

					{/each}
					
				</select>

			</div>

		</div>

	</div>

	{#if !!active_division_instance_id}

	<div class="field">

		<div class="control">

			<label>
				Team
			</label>

			<div class="select is-fullwidth">

				<select bind:value={$form.team_instance_id} disabled={loading}>

					<option value="">
						Team
					</option>

					{#each active_team_instances as team_instance}
						<option value="{team_instance.id}">
							{team_instance.teams_sc.name}
						</option>
					{/each}

				</select>

			</div>

			{#if $errors.team_instance_id}
				<FormFieldError detail={'Select a valid team!'} />
			{/if}

		</div>

	</div>


	<br>


	{#if !!$form.team_instance_id}

	<!-- Actual form data! -->

	<div class="field">

		<div class="control">

			<label>
				Contact Email
			</label>

			<input placeholder="Contact Email" class="input" type="text" id="contact_email" name="contact_email" on:change={handleChange} bind:value={$form.contact_email} disabled={loading}>

			{#if $errors.contact_email}
				<FormFieldError detail={$errors.contact_email} />
			{/if}

		</div>

	</div>


	<div class="field">

		<div class="control">

			<label>
				Contact Phone #
			</label>

			<input placeholder="Contact Phone #" class="input" type="text" id="contact_phone_number" name="contact_phone_number" on:change={handleChange} bind:value={$form.contact_phone_number} disabled={loading}>

			{#if $errors.contact_phone_number}
				<FormFieldError detail={$errors.contact_phone_number} />
			{/if}

		</div>

	</div>


	<div class="field">

		<div class="control">

			<label>
				Player Full Name
			</label>

			<input placeholder="Player Full Name" class="input" type="text" id="player_full_name" name="player_full_name" on:change={handleChange} bind:value={$form.player_full_name} disabled={loading}>

			{#if $errors.player_full_name}
				<FormFieldError detail={$errors.player_full_name} />
			{/if}

		</div>

	</div>


	<!-- --- -->
	<br>
	<br>

	<MsgCard msg_show={true} msg_text={'Aliquip culpa labore magna culpa in id officia aliqua reprehenderit sunt sed magna aliqua id aliquip officia.'} msg_type={'error'} msg_forever={true} />


	{#each $form.jersey_sponsors as jersey_sponsor, i}

		<div class="field">

			<div class="control">

				<div class="columns is-variable is-vcentered is-2">

					<div class="column">
						<label style="margin-bottom: 0 !important; font-size: 1.225rem !important; color: #3c3c3c;">
							Sponsor {i + 1}
						</label>
					</div>

					<div class="column is-narrow">
						{#if $form.jersey_sponsors.length === 1}
						<span class="button is-custom-red is-small is-invisible" style="margin-top: 0 !important;">
							Remove
						</span>
						{:else}
						<span class="button is-custom-red is-small" style="margin-top: 0 !important;" on:click={() => removeJerseySponsor(i)}>
							Remove
						</span>
						{/if}
					</div>

				</div>

			</div>

		</div>


		<div class="field">

			<div class="control">

				<input placeholder="Name of Sponsor" class="input" type="text" id="jersey_sponsors.{i}.name_of_sponsor" name="jersey_sponsors.{i}.name_of_sponsor" on:change={handleChange} bind:value={$form.jersey_sponsors[i].name_of_sponsor} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].name_of_sponsor}
					<FormFieldError detail={$errors.jersey_sponsors[i].name_of_sponsor} />
					{/if}
				{/if}

			</div>

		</div>


		<div class="field">

			<div class="control">

				<label class="checkbox">
					<input type="checkbox" bind:checked={$form.jersey_sponsors[i].no_sponsor_bar} on:change={handleChange} style="margin-right: 0.5rem;" disabled={loading}>
					No Sponsor Bar?
				</label>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].no_sponsor_bar}
					<FormFieldError detail={$errors.jersey_sponsors[i].no_sponsor_bar} />
					{/if}
				{/if}

			</div>

		</div>


		<!-- -- -->


		<div class="field">

			<div class="control">

				<input placeholder="Sponsor Line 1" class="input" type="text" id="jersey_sponsors.{i}.sponsor_line_1" name="jersey_sponsors.{i}.sponsor_line_1" on:change={handleChange} bind:value={$form.jersey_sponsors[i].sponsor_line_1} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].sponsor_line_1}
					<FormFieldError detail={$errors.jersey_sponsors[i].sponsor_line_1} />
					{/if}
				{/if}

			</div>

		</div>


		<div class="field">

			<div class="control">

				<input placeholder="Sponsor Line 2" class="input" type="text" id="jersey_sponsors.{i}.sponsor_line_2" name="jersey_sponsors.{i}.sponsor_line_2" on:change={handleChange} bind:value={$form.jersey_sponsors[i].sponsor_line_2} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].sponsor_line_2}
					<FormFieldError detail={$errors.jersey_sponsors[i].sponsor_line_2} />
					{/if}
				{/if}

			</div>

		</div>


		<div class="field">

			<div class="control">

				<input placeholder="Sponsor Amount" class="input" type="number" id="jersey_sponsors.{i}.amount" name="jersey_sponsors.{i}.amount" on:change={handleChange} bind:value={$form.jersey_sponsors[i].amount} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].amount}
					<FormFieldError detail={$errors.jersey_sponsors[i].amount} />
					{/if}
				{/if}

			</div>

		</div>


		{#if $form.jersey_sponsors.length > 1 && i !== $form.jersey_sponsors.length - 1}
		<hr style="">
		{/if}


	{/each}



	<!-- breaker ..? -->



	<div class="button is-small is-custom" style="margin-top: 1rem !important;" on:click={addNewJerseySponsor}>
		Add Another Sponsor
		<i class="far fa-plus" style=""></i>
	</div>

	<br>

	<br>

	<!-- --- -->

	{/if}

	{/if}

	{/if}

	<br class:is-hidden={!$form.team_instance_id}>

	<div class="field" class:is-hidden={!$form.team_instance_id}>

		<div class="control">

			<div bind:this={captcha} />

			{#if $errors['h-captcha-response']}
				<FormFieldError detail={"Prove you're not a bot!"} />
			{/if}

		</div>

	</div>

	<br class:is-hidden={!$form.team_instance_id}>

	<div class="field" class:is-hidden={!$form.team_instance_id}>

		<div class="control">

			<button class="button is-blue is-fullwidth">
				<span>Submit Form</span>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!loading}></i>
			</button>

		</div>

		<!-- <div class="control">

			<Navigate styles="form-card-link" to="/code/send-new">
				<span>Forgot Code or Email?</span>
			</Navigate>

		</div> -->

	</div>


</form>






